import { CategoryWithSubcategories } from '../../../domain/category/entities/CategoryWithSubcategories';
import { CategoryRepository } from '../../../domain/category/repositories/CategoryRepository';
import { categories } from '../data/categories';
import { logger } from '../../../shared/utils/logger';

export class LocalCategoryRepository extends CategoryRepository {
  async getAll() {
    logger.debug('📖 Chargement des catégories locales...');
    return Promise.resolve(categories.map(data => new CategoryWithSubcategories(data)));
  }

  async getById(id) {
    const categoryData = categories.find(c => c.id === id);
    if (!categoryData) {
      return Promise.resolve(null);
    }
    return Promise.resolve(new CategoryWithSubcategories(categoryData));
  }
} 